import {  memo  } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Box from '@mui/material/Box';
import Modal from 'react-modal';


const SlackImage = memo((props) => {
    const {isOpen , modalClose , url} = props;
    Modal.setAppElement('#root');
    return (
        url && isOpen &&
        <>
        <Modal 
            className="modal-wrap" 
            style={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.75)'
                }
            }}
            sx={{ pointerEvents: 'none' }}                
            isOpen={isOpen}>
            <Box className="slackImgWrap" sx={{xIndex:200000}}>
                <IconButton 
                    sx={{position:'absolute',right:"-5px" ,top:"-5px",color:'white', zIndex:100010}}
                    size="large"
                >
                    <CloseIcon onClick={modalClose} />
                </IconButton>
                <img className="modal-img" src={ url }/>
            </Box>
        </Modal>
        </>
    )    
});
export default SlackImage